import { useEffect, useState } from "react";
import { _Knowledge } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";

interface PropKnowledge {
    _IDAppointManual: number;
}

export const Knowledge = ({ _IDAppointManual }: PropKnowledge) => {

    const knowledge = useDataBean(_Knowledge);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Eliminar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        if (_IDAppointManual >= 0) {
            getLista();
        }
    }, [_IDAppointManual])

    const getLista = () => {

        knowledge.instance.getKnowledgeCatalog(null, _IDAppointManual, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                   //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        knowledge.setBean({
            IDAppointmentManual: _IDAppointManual,
        });
        setModal({ ...modal, "name": "Agregar Conocimiento al cargo", "view": true });
    }

    const deleteItem = () => {
        knowledge.instance.deleteKnowledge(knowledge.bean).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }

    const editaItem = () => {
        knowledge.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDKnowledge', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar conocimiento del cargo`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={knowledge.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Descripción:</label>
                            <textarea name="Description" className="form-control" value={knowledge.bean.Description} onChange={knowledge.handleChange} />
                        </div>

                    </div>
                </Modal>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {knowledge.bean.IDKnowledge}</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}